import type { CompositionInsetMap } from './model';

/** Renderer-independent inset furniture defaults, also used by page presets. */
export interface InsetDefaultContent {
  readonly layers?: readonly { readonly id: string }[];
  readonly annotationLayers?: readonly { readonly id: string }[];
}

export function createDefaultInsetMap(content: InsetDefaultContent = {}): CompositionInsetMap {
  return {
    hiddenLayerIds: content.layers?.map(({ id }) => id) ?? [],
    hiddenAnnotationLayerIds: content.annotationLayers?.map(({ id }) => id) ?? [],
    hiddenAnnotationIds: [],
    bounds: { x: 0.075, y: 0.68, width: 0.25, height: 0.24 },
    contextMargin: 50,
    border: { enabled: true, widthMm: 0.3, colour: '#52606d' },
    cornerRadiusMm: 1.5,
    indicator: {
      outlineColour: '#2f3437',
      outlineWidthMm: 0.4,
      fillColour: '#246b89',
      fillOpacity: 0,
    },
  };
}
